import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "scroll-container",
  style: {
    "user-select": "none"
  }
};
const _hoisted_2 = {
  id: "loader-wrapper"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "progress-bar"
};
const _hoisted_5 = {
  else: ""
};
const _hoisted_6 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageOne = _resolveComponent("PageOne");
  const _component_PageTwo = _resolveComponent("PageTwo");
  const _component_PageThree = _resolveComponent("PageThree");
  const _component_PageThree1 = _resolveComponent("PageThree1");
  const _component_PageFour = _resolveComponent("PageFour");
  const _component_PageFour2 = _resolveComponent("PageFour2");
  const _component_PageFour3 = _resolveComponent("PageFour3");
  const _component_PageFour4 = _resolveComponent("PageFour4");
  const _component_PageFour51 = _resolveComponent("PageFour51");
  const _component_PageFour511 = _resolveComponent("PageFour511");
  const _component_PageFour512 = _resolveComponent("PageFour512");
  const _component_PageFour52 = _resolveComponent("PageFour52");
  const _component_PageFour53 = _resolveComponent("PageFour53");
  const _component_PageFour54 = _resolveComponent("PageFour54");
  const _component_PageFour55 = _resolveComponent("PageFour55");
  const _component_PageFour56 = _resolveComponent("PageFour56");
  const _component_PageFour57 = _resolveComponent("PageFour57");
  const _component_PageFour58 = _resolveComponent("PageFour58");
  const _component_PageFour513 = _resolveComponent("PageFour513");
  const _component_PageFour514 = _resolveComponent("PageFour514");
  const _component_PageFour59 = _resolveComponent("PageFour59");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.loadingSvg,
    alt: "Loading...",
    style: {
      "display": "flex"
    }
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "progress-inner",
    style: _normalizeStyle({
      width: $data.loadProgress + '%'
    })
  }, null, 4)])], 512), [[_vShow, $data.isLoading]]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "music-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleMusic && $options.toggleMusic(...args))
  }, [_createElementVNode("img", {
    src: $data.isPlaying ? $data.playingIcon : $data.pausedIcon,
    class: _normalizeClass({
      rotating: $data.isPlaying
    }),
    alt: "Music Button"
  }, null, 10, _hoisted_6)]), _createElementVNode("div", null, [_createVNode(_component_PageOne), _createVNode(_component_PageTwo, {
    onGoHome: $options.handleGoHome,
    onScrollToPage2: $options.scrollToPage
  }, null, 8, ["onGoHome", "onScrollToPage2"]), _createVNode(_component_PageThree, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageThree1, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour2, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour3, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour4, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour51, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour511, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour512, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour52, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour53, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour54, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour55, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour56, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour57, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour58, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour513, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour514, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"]), _createVNode(_component_PageFour59, {
    onGoHome: $options.handleGoHome
  }, null, 8, ["onGoHome"])])])]);
}